import React from 'react';
import { format } from 'date-fns';
import { FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import { DatePicker } from '@/components/date/date-picker';
import { cn } from '@/lib/utils';
const ISO = 'yyyy-MM-dd';
const parseISO = (value) => {
    if (typeof value !== 'string' || value === '') {
        return undefined;
    }
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? undefined : date;
};
function DateFieldInner({ control, name, label, description, disabled, nullable, className, }) {
    return (<FormField control={control} name={name} render={({ field }) => (<FormItem className={cn('space-y-2', className)}>
                    {label && <FormLabel>{label}</FormLabel>}
                    <FormControl>
                        <DatePicker disabled={disabled} nullable={nullable} value={parseISO(field.value)} onChange={(date) => field.onChange(date ? format(date, ISO) : '')}/>
                    </FormControl>
                    {description && <FormDescription>{description}</FormDescription>}
                    <FormMessage />
                </FormItem>)}/>);
}
DateFieldInner.displayName = 'DateField';
export const DateField = React.memo(DateFieldInner);
